<template>
  <div class="sub-form-text sub-columns">
    <BaseInput type="number" name="min value" :validate="minValidator" class="sub-col" v-model="form.min" label="Min characters length"/>
    <BaseInput type="number" name="max value" validate="required|integer|min_value:0" class="sub-col" v-model="form.max" label="Max characters length" hint="0 = unlimited number of characters"/>
  </div>
</template>

<script>
  import subformMixin from '@/mixins/sub-form.mixin'

  export default {
    mixins: [ subformMixin ],
    data () {
      return {
        form: {
          min: '0',
          max: '200'
        }
      }
    },
    computed: {
      minValidator () {
        return `required|integer|min_value:0|${this.form.max == 0 ? '' : '|max_value:' + this.form.max }`
      }
    }
  }
</script>

<style lang="scss">

  .sub-form-text {
  }
</style>


// WEBPACK FOOTER //
// src/components/forms/sub-forms/SubFormText.vue